var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteBgTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1538,
    height: 184,
    viewBox: "0 0 1538 184",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-WhiteBG_Top"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1538,
    height: 184
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "WhiteBG_Top",
    clipPath: "url(#clip-WhiteBG_Top)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Intersection_7",
    "data-name": "Intersection 7",
    d: "M149.843,1299.357c-54.9-14.711-99.852-66.114-109.905-130.288V1119.6h1538c-6.785,59.273-48.977,104.767-104.772,108.384-.4-.234-50.2,3.6-50.2,3.6l-1233.3,71.763q-1.812.119-3.622.181-2.123.074-4.235.074A123.5,123.5,0,0,1,149.843,1299.357Z",
    transform: "translate(-39.938 -1119.599)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteBgTop);
export default __webpack_public_path__ + "static/media/WhiteBG_Top.95512fa845bfe6078d71b80567c9d807.svg";
export { ForwardRef as ReactComponent };